import { type PhoebeAgentRunStateRead } from '@apps/web/hooks/use_phoebe_agent_run_event_stream';

export function isApprovalOnlyRunState(
    runState: PhoebeAgentRunStateRead,
): boolean {
    return (
        runState.has_pending_approval &&
        !runState.has_pending_work &&
        !runState.has_active_lease
    );
}

export function isUserInputOnlyRunState(
    runState: PhoebeAgentRunStateRead,
): boolean {
    return (
        runState.has_pending_user_input &&
        !runState.has_pending_work &&
        !runState.has_active_lease
    );
}

export function isActiveRunState(runState: PhoebeAgentRunStateRead): boolean {
    return (
        runState.status === 'running' ||
        runState.has_active_lease ||
        runState.has_pending_work ||
        runState.is_generating ||
        runState.interrupt_requested
    );
}
